import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin: 20px 0;
  .action {
    border: ${({ theme }) => `1px solid  ${theme.default.color.text.light}`}; 
    border-collapse: collapse;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    @media (max-width: ${defaultBreakpoints.medium}) {
        border: 0;
      border-bottom: ${({ theme }) => `1px solid ${theme.default.color.text.light}`}; 
    }
  }
  svg {
    fill: ${({ theme }) => theme.default.color.primary};
    color: ${({ theme }) => theme.default.color.primary};
    font-size: 36px;
    margin-bottom: 1rem;
  }
  @media (max-width: ${defaultBreakpoints.medium}) {
    grid-template-columns: 1fr 1fr;
    column-gap: 20px;
  }
`;
